(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mori-cart-gifts"] && !Shopify.designMode) return;
  try {
    (() => {
    const RULES = {
      always: () => true,
      subscribe: (s) => s.subscription,
      tins_2: (s) => s.tins >= 2,
      tins_3: (s) => s.tins >= 3,
      subscribe_or_tins_2: (s) => s.subscription || s.tins >= 2,
      subscribe_and_tins_3: (s) => s.subscription && s.tins >= 3,
      // A whisk only counts as a gift when the shopper is not already getting
      // one inside an essentials kit, whether that kit was bought (Essentials
      // Kit, Matcha Gift Set) or given free on a 3-tin order. A popup claim
      // opens it up to one-off single tins too.
      whisk_outside_kit: (s) => (s.subscription || s.tins >= 2 || s.claim) && s.tins < 3 && !s.kit,
    };

    const readConfig = () => {
      const node = document.getElementById('MoriGiftConfig');
      if (!node) return null;
      try {
        // Tolerate the trailing comma Liquid can leave when a gift product is missing.
        return JSON.parse(node.textContent.replace(/,\s*]/, ']'));
      } catch (error) {
        return null;
      }
    };

    const postJSON = (url, body) =>
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      }).then((response) => response.json());

    let pending = null;
    let queued = false;

    // Runs one sync at a time. A call made mid-sync queues one more pass, and the
    // returned promise settles only once the cart is fully synced, so the direct
    // checkout path can wait for the free gifts before it leaves the page.
    function syncGifts() {
      if (pending) {
        queued = true;
        return pending;
      }
      pending = (async () => {
        do {
          queued = false;
          await runGiftSync();
        } while (queued);
      })().finally(() => {
        pending = null;
      });
      return pending;
    }

    window.__moriSyncGifts = syncGifts;

    // The cart as of the last sync, so an add can plan its gifts without waiting on
    // another /cart.js. Any cart update clears it; if it is stale anyway, the sync
    // that follows every add puts the gifts right.
    let knownCart = null;

    const fetchCart = () => fetch(`${window.routes?.cart_url || '/cart'}.js`).then((response) => response.json());

    // A Matcha Gift Set added from its own page carries `_mori_bundle` on all three of its lines
    // (kit, tin of matcha, GBP 0 storage tin). While it still holds both its kit and its tin it is
    // left alone: it brings its own gift, and a Mori Matcha order alongside it keeps its own gifts
    // instead of the two being pooled. A bundle missing either half stops counting as one, so its
    // remaining lines are treated like any other.
    const bundleOf = (item) => (item.properties && item.properties._mori_bundle) || '';

    function completeBundles(config, cart) {
      const kitVariantIds = new Set((config.kit_variant_ids || []).map(Number));
      const parts = new Map();
      cart.items.forEach((item) => {
        const bundle = bundleOf(item);
        if (!bundle || isGiftLine(item)) return;
        const part = parts.get(bundle) || { kit: false, tin: false };
        if (kitVariantIds.has(Number(item.variant_id))) part.kit = true;
        if (config.variants[item.variant_id]) part.tin = true;
        parts.set(bundle, part);
      });
      return new Set([...parts].filter(([, part]) => part.kit && part.tin).map(([bundle]) => bundle));
    }

    // Works out which gift lines this cart should hold and what has to change to get there.
    function planGifts(config, cart) {
      const kitVariantIds = new Set((config.kit_variant_ids || []).map(Number));
      const bundles = completeBundles(config, cart);
      const inBundle = (item) => bundles.has(bundleOf(item));
      const state = { tins: 0, subscription: false, kit: false, claim: Boolean((cart.attributes || {})._mori_whisk_claim) };
      let bundleSubscription = false;
      cart.items.forEach((item) => {
        if (item.properties && item.properties._mori_gift) return;
        if (inBundle(item)) {
          if (config.variants[item.variant_id] && item.selling_plan_allocation) bundleSubscription = true;
          return;
        }
        if (kitVariantIds.has(Number(item.variant_id))) state.kit = true;
        const tins = config.variants[item.variant_id];
        if (!tins) return;
        state.tins = Math.max(state.tins, tins);
        if (item.selling_plan_allocation) state.subscription = true;
      });

      // Which variant of a gift belongs in this cart. The Buy X Get Y discounts
      // free the real Storage Tin only alongside the real Whisk, so a gift-set
      // cart (kit instead of whisk) takes the GBP 0 tin, and a cart without the
      // kit takes the real one. Removing the kit therefore swaps the tin line
      // over, which is what lets the whisk come through free as well.
      const variantFor = (gift) => Number(state.kit && gift.kit_variant_id ? gift.kit_variant_id : gift.variant_id);

      // Wanted quantity and variant per gift key; storage tins come one per tin of matcha.
      const wanted = new Map(
        state.tins > 0
          ? config.gifts
              .filter((gift) => (RULES[gift.rule] || RULES.always)(state))
              .map((gift) => [
                gift.key,
                { gift, quantity: gift.per_tin ? state.tins : 1, variantId: variantFor(gift) },
              ])
          : []
      );

      const updates = {};
      const present = new Set();
      cart.items.forEach((item) => {
        const key = item.properties && item.properties._mori_gift;
        if (!key) return;
        if (bundleOf(item)) {
          // A bundle's own gift stays exactly as it was added, and goes when its bundle breaks up.
          if (!inBundle(item)) updates[item.key] = 0;
          return;
        }
        const want = wanted.get(key);
        // A gift line on the wrong variant is dropped here and re-added below,
        // so the cart always holds the variant the discounts are written against.
        if (!want || present.has(key) || Number(item.variant_id) !== want.variantId) {
          updates[item.key] = 0;
        } else {
          present.add(key);
          if (item.quantity !== want.quantity) updates[item.key] = want.quantity;
        }
      });

      const additions = [...wanted.values()]
        .filter((want) => !present.has(want.gift.key))
        .map((want) => {
          const properties = { _mori_gift: want.gift.key };
          // The GBP 0 tin carries no price of its own, so the cart is told what
          // the gift is worth rather than reading it off the line.
          if (want.gift.worth > 0) properties._mori_gift_worth = String(want.gift.worth);
          return { id: want.variantId, quantity: want.quantity, properties };
        });

      // The subscribe-route code only holds while a subscribed tin is in the
      // cart, so clear the recorded amount once that stops being true or the
      // cart would keep showing a saving the shopper will not get.
      const recordedDiscount = Number((cart.attributes || {})._mori_code_discount || 0);
      const clearRecordedDiscount = recordedDiscount > 0 && !state.subscription && !bundleSubscription;

      // The popup code only goes on when the claim is the sole reason for the
      // whisk (a one-off single tin). Subscriptions and 2 tins already get it
      // from the automatic discounts, and holding the code there would use up
      // the shopper's one claim for nothing.
      const claimCode = String(config.whisk_claim_code || '').toUpperCase();
      const cartCodes = (cart.discount_codes || []).map((discount) => discount.code);
      const hasCode = (wanted) => cartCodes.some((code) => code.toUpperCase() === wanted);
      const hasClaimCode = hasCode(claimCode);
      const needsClaimCode =
        Boolean(claimCode) && wanted.has('whisk') && !state.subscription && state.tins < 2;
      let nextCodes = cartCodes;
      if (needsClaimCode && !hasClaimCode) nextCodes = [...nextCodes, claimCode];
      if (!needsClaimCode && hasClaimCode) {
        nextCodes = nextCodes.filter((code) => code.toUpperCase() !== claimCode);
      }

      // The Gift Set page records the code behind its quoted subscription saving.
      // Applying it can fail without the page noticing (its /discount/ fallback
      // only sets a cookie, which an existing cart ignores), so the code goes back
      // on whenever the cart is missing it. A code Shopify holds but won't apply
      // (already used by this customer, say) stays listed, so this never loops.
      const subscribeCode = String((cart.attributes || {})._mori_code_discount_code || '').toUpperCase();
      if (subscribeCode && recordedDiscount > 0 && !clearRecordedDiscount && !hasCode(subscribeCode)) {
        nextCodes = [...nextCodes, subscribeCode];
      }
      const discountCodes = nextCodes === cartCodes ? null : nextCodes;

      return { updates, additions, clearRecordedDiscount, discountCodes };
    }

    const isGiftLine = (item) => Boolean(item.properties && item.properties._mori_gift);

    // Called by product-form.js just before a Mori Matcha tin is added. Plans the gifts as if
    // the tin were already in the cart, applies any changes to existing lines, and returns the
    // new gift lines so they go in the same /cart/add.js request as the tin. The drawer then
    // opens with its gifts already in place instead of filling them in afterwards.
    // Resolves null when the line isn't a Mori Matcha tin.
    window.__moriPrepareGiftAdd = async (line) => {
      const config = readConfig();
      if (!config || !config.variants[line.id]) return null;

      const pendingLine = {
        variant_id: Number(line.id),
        properties: {},
        selling_plan_allocation: line.selling_plan ? { selling_plan: { id: Number(line.selling_plan) } } : null,
      };
      const kitVariantIds = new Set((config.kit_variant_ids || []).map(Number));
      let cart = knownCart || (await fetchCart());
      knownCart = null;

      // A new choice on the Mori Matcha page replaces the tins already in the cart rather than
      // stacking a second plan and a second set of gifts on top. A cart holding a kit keeps its
      // tins, since kit and tin together make a gift set. Anything added as a Matcha Gift Set,
      // whole or not, is never replaced: the cart shows it as its own order.
      const isLoose = (item) => !isGiftLine(item) && !bundleOf(item);
      const replaces =
        !cart.items.some((item) => isLoose(item) && kitVariantIds.has(Number(item.variant_id))) &&
        cart.items.some((item) => isLoose(item) && config.variants[item.variant_id]);
      const isReplacedTin = (item) => replaces && isLoose(item) && Boolean(config.variants[item.variant_id]);
      const withLine = (current) => ({
        ...current,
        items: [...current.items.filter((item) => !isReplacedTin(item)), pendingLine],
      });

      let plan = planGifts(config, withLine(cart));
      cart.items.filter(isReplacedTin).forEach((item) => {
        plan.updates[item.key] = 0;
      });

      // Replaced tins and gift lines that need a new quantity or variant change first, then the
      // additions are planned again against the result.
      if (Object.keys(plan.updates).length) {
        cart = await postJSON(`${window.routes?.cart_update_url || '/cart/update'}.js`, { updates: plan.updates });
        // The remembered cart can be out of date (changed in another tab, say), so an update
        // naming lines that have gone comes back as an error rather than a cart.
        if (!Array.isArray(cart.items)) cart = await fetchCart();
        plan = planGifts(config, withLine(cart));
      }
      return plan.additions;
    };

    // Called by cart.js before a cart line's quantity changes. Returns every change the cart
    // needs to end up right, the line itself plus any gift lines, so they can all be applied
    // before the drawer redraws once. Resolves null when no gift changes, leaving the plain
    // /cart/change.js call to it.
    window.__moriPlanLineChange = async (lineIndex, quantity) => {
      const config = readConfig();
      if (!config) return null;

      const cart = await fetchCart();
      knownCart = null;
      const item = cart.items[Number(lineIndex) - 1];
      if (!item || isGiftLine(item)) return null;

      const after = {
        ...cart,
        items: cart.items
          .map((current) => (current.key === item.key ? { ...current, quantity } : current))
          .filter((current) => current.quantity > 0),
      };
      const plan = planGifts(config, after);
      if (!Object.keys(plan.updates).length && !plan.additions.length) return null;
      return { updates: { ...plan.updates, [item.key]: quantity }, additions: plan.additions };
    };

    async function runGiftSync() {
      const config = readConfig();
      if (!config) return;

      try {
        const cart = await fetchCart();
        knownCart = cart;
        const { updates, additions, clearRecordedDiscount, discountCodes } = planGifts(config, cart);

        let changed = false;
        if (clearRecordedDiscount) {
          await postJSON(`${window.routes?.cart_update_url || '/cart/update'}.js`, {
            attributes: { _mori_code_discount: '', _mori_code_discount_label: '', _mori_code_discount_code: '' },
          });
          changed = true;
        }
        if (Object.keys(updates).length) {
          await postJSON(`${window.routes?.cart_update_url || '/cart/update'}.js`, { updates });
          changed = true;
        }
        if (additions.length) {
          await postJSON(`${window.routes?.cart_add_url || '/cart/add'}.js`, { items: additions });
          changed = true;
        }
        if (discountCodes) {
          await postJSON(`${window.routes?.cart_update_url || '/cart/update'}.js`, { discount: discountCodes.join(',') });
          changed = true;
        }
        if (changed) {
          knownCart = null;
          await refreshCart();
        }
      } catch (error) {
        console.error('Mori gift sync failed', error);
      }
    }

    // Swaps one rendered section, following Dawn's own pattern: pull the
    // matching node out of the returned HTML and replace the live element's
    // contents with it.
    const swapSection = (html, host, selector) => {
      if (!html || !host) return;
      const source = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      if (source) host.innerHTML = source.innerHTML;
    };

    // Every cart surface currently on the page. The drawer is rendered
    // everywhere, but /cart also renders its own rows and footer, and those
    // rows carry the line INDEX that /cart/change.js works from. Leaving them
    // stale after a gift sync makes the shopper's next remove target the wrong
    // line and fail with "there was an error while updating your cart".
    const cartRenderTargets = () => {
      const targets = [];

      if (document.querySelector('cart-drawer')) {
        targets.push({ section: 'cart-drawer', host: document.querySelector('#CartDrawer'), selector: '#CartDrawer' });
      }

      // <cart-items> is the cart page's own component; the drawer's is
      // <cart-drawer-items>, so this matches the page one only.
      document
        .querySelector('cart-items')
        ?.getSectionsToRender()
        .forEach((section) => {
          const wrapper = document.getElementById(section.id);
          if (!wrapper) return;
          targets.push({
            section: section.section,
            host: wrapper.querySelector(section.selector) || wrapper,
            selector: section.selector,
          });
        });

      if (!targets.some((target) => target.section === 'cart-icon-bubble')) {
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble) targets.push({ section: 'cart-icon-bubble', host: bubble, selector: '.shopify-section' });
      }

      return targets.filter((target) => target.host);
    };

    // This runs in the background, so it must leave the drawer exactly as open
    // or closed as it found it. Dawn's renderContents() always opens the drawer
    // (its open() is deferred in a setTimeout, so closing straight afterwards
    // does not stick), so the sections are swapped directly instead.
    async function refreshCart() {
      const targets = cartRenderTargets();
      if (targets.length === 0) return;

      const sections = [...new Set(targets.map((target) => target.section))];
      const response = await fetch(`${window.location.pathname}?sections=${sections.join(',')}`);
      const rendered = await response.json();

      targets.forEach((target) => swapSection(rendered[target.section], target.host, target.selector));

      const hasItems = Boolean(document.querySelector('.cart-item'));
      document.querySelector('cart-drawer')?.classList.toggle('is-empty', !hasItems);
      document.getElementById('main-cart-footer')?.classList.toggle('is-empty', !hasItems);

      if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mori-gift-sync' });
    }

    const start = () => {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event && event.source === 'mori-gift-sync') return;
          knownCart = null;
          syncGifts();
        });
      }
      syncGifts();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mori-gift-set-builder"] && !Shopify.designMode) return;
  try {
    class MoriGiftSetBuilder extends HTMLElement {
    connectedCallback() {
      this.essentialsVariantId = this.dataset.essentialsVariantId;
      this.matchaVariantId = this.dataset.matchaVariantId;
      this.storageTinVariantId = this.dataset.storageTinVariantId;
      this.storageTinWorthCents = this.dataset.storageTinWorthCents;
      this.subscribeDiscountCode = this.dataset.subscribeDiscountCode;
      this.extraDiscountCents = Number(this.dataset.extraDiscountCents || 0);
      this.extraDiscountLabel = this.dataset.extraDiscountLabel || 'Subscription saving';
      this.essentialsCents = Number(this.dataset.essentialsCents || 0);
      this.matchaOnceCents = Number(this.dataset.matchaOnceCents || 0);
      this.matchaSubCents = Number(this.dataset.matchaSubCents || 0);
      this.matchaFullCents = Number(this.dataset.matchaFullCents || 0);

      this.onceInput = this.querySelector('[value="once"]');
      this.subscribeInput = this.querySelector('[value="subscribe"]');
      this.totalPriceEl = this.querySelector('[data-total-price]');
      this.tinLineEl = this.querySelector('[data-tin-price]');
      this.tinFullPriceEl = this.querySelector('[data-tin-full-price]');
      this.tinPlanLabelEl = this.querySelector('[data-tin-plan-label]');
      this.subscriptionPerkEls = this.querySelectorAll('[data-subscription-perk]');
      this.bannerEl = this.querySelector('[data-summary-banner]');
      this.extraDiscountNoteEl = this.querySelector('[data-extra-discount-note]');
      this.submitButton = this.querySelector('[data-add-to-cart]');
      this.buttonText = this.querySelector('[data-button-text]');
      this.spinner = this.querySelector('[data-spinner]');
      this.errorEl = this.querySelector('[data-error]');

      this.addEventListener('change', (event) => {
        const name = event.target.name;
        if (name?.startsWith('mori-gift-plan-')) {
          this.updateSummary();
        }
      });
      this.submitButton?.addEventListener('click', this.addToCart.bind(this));

      this.updateSummary();
    }

    formatMoney(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency',
          currency: this.dataset.currency || 'GBP',
        }).format(cents / 100);
      } catch {
        return `£${(cents / 100).toFixed(2)}`;
      }
    }

    isSubscribing() {
      return this.subscribeInput?.checked === true;
    }

    updateSummary() {
      const subscribing = this.isSubscribing();
      const tinCents = subscribing ? this.matchaSubCents : this.matchaOnceCents;
      const total = this.essentialsCents + tinCents;

      // Drives the sticky add-to-cart bar's "Save X%" label: the full total compares
      // the essentials kit against the matcha tin's compare-at (its "was") price.
      const fullTotal = this.essentialsCents + this.matchaFullCents;
      const currentSaving = fullTotal > total ? Math.round(((fullTotal - total) / fullTotal) * 100) : 0;
      this.dataset.currentSavingPercent = String(currentSaving);

      if (this.totalPriceEl) this.totalPriceEl.textContent = this.formatMoney(total);
      if (this.tinLineEl) this.tinLineEl.textContent = this.formatMoney(tinCents);
      // Struck price is the tin's compare-at, so it shows on one-off orders too while the tin is reduced.
      if (this.tinFullPriceEl) this.tinFullPriceEl.hidden = tinCents >= this.matchaFullCents;
      // The 4-week cadence is its own tick below, so the tin line only flags the plan.
      if (this.tinPlanLabelEl) this.tinPlanLabelEl.textContent = subscribing ? '(subscribed)' : '(one-off)';
      this.subscriptionPerkEls.forEach((perk) => {
        perk.hidden = !subscribing;
      });
      if (this.extraDiscountNoteEl) this.extraDiscountNoteEl.hidden = !subscribing;
      if (this.bannerEl) this.bannerEl.hidden = !subscribing;
    }

    discountUrl(redirectPath) {
      const root = window.routes?.root_url || '/';
      return `${root}discount/${encodeURIComponent(this.subscribeDiscountCode)}?redirect=${encodeURIComponent(redirectPath)}`;
    }

    // Shopify holds a discount code in the `discount_code` cookie and applies
    // it to the cart, so it shows in /cart.js as a line discount on the tin.
    // Requesting the route in the background achieves everything the old
    // navigation to /cart did, and the cookie is the proof it landed.
    async applySubscribeDiscount() {
      try {
        const response = await fetch(this.discountUrl(window.routes?.cart_url || '/cart'), {
          credentials: 'same-origin',
        });
        if (!response.ok) return false;
        // The cookie is readable in a normal first-party context. Where script
        // cannot see it (some in-app browsers), a successful request is taken
        // as good enough rather than bouncing the shopper to the cart page.
        const stored = this.storedDiscountCode();
        return stored === null || stored === this.subscribeDiscountCode.trim().toUpperCase();
      } catch (error) {
        return false;
      }
    }

    async applySubscribeDiscountToCart(sections) {
      try {
        const response = await fetch(`${window.routes?.cart_update_url || '/cart/update'}.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ discount: this.subscribeDiscountCode, ...(sections ? { sections } : {}) }),
        });
        if (!response.ok) return null;
        const cart = await response.json();
        const code = this.subscribeDiscountCode.trim().toUpperCase();
        const applied = (cart.discount_codes || []).some(
          (discount) => discount.applicable && String(discount.code).trim().toUpperCase() === code
        );
        return applied ? cart : null;
      } catch (error) {
        return null;
      }
    }

    storedDiscountCode() {
      const match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
      if (!match) return null;
      try {
        return decodeURIComponent(match[1]).trim().toUpperCase();
      } catch (error) {
        return match[1].trim().toUpperCase();
      }
    }

    async addToCart() {
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.errorEl.hidden = true;
      this.submitButton.setAttribute('aria-disabled', 'true');
      this.buttonText.textContent = 'Adding…';
      this.spinner.hidden = false;

      // Tags all three lines as one bundle, so the cart keeps them together as their own order
      // next to anything else in it (see snippets/mori-cart-gifts.liquid and cart-drawer.liquid).
      // Each add gets its own id, so a Gift Set added again never merges into what is left of
      // an earlier one (its tin of matcha after the kit was removed, say).
      const bundle = { _mori_bundle: `gift-set-${Date.now().toString(36)}` };
      const items = [{ id: Number(this.essentialsVariantId), quantity: 1, properties: { ...bundle } }];
      const matchaItem = { id: Number(this.matchaVariantId), quantity: 1, properties: { ...bundle } };
      if (this.isSubscribing()) {
        if (this.dataset.sellingPlanId) matchaItem.selling_plan = Number(this.dataset.sellingPlanId);
      }
      items.push(matchaItem);
      if (this.storageTinVariantId) {
        // Marks this line as a gift so the cart drawer's existing
        // "Included free" box (see snippets/cart-drawer.liquid) picks it
        // up automatically instead of listing it as a normal product.
        items.push({
          id: Number(this.storageTinVariantId),
          quantity: 1,
          // Uses the cart gift sync's own 'tin' key (see snippets/mori-cart-gifts.liquid)
          // so that sync recognises this line instead of removing it as an
          // unknown gift and adding the standalone storage tin in its place.
          properties: { _mori_gift: 'tin', _mori_gift_worth: this.storageTinWorthCents || '', ...bundle },
        });
      }

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = { items };

      // Shopify only redeems a discount code at checkout, so the cart would
      // otherwise read GBP 2 higher than this page and than what is actually
      // charged. Recording the code's value on the cart lets the drawer and the
      // cart page show the same total the shopper was quoted here. Sent with
      // the add so the sections it returns already include it.
      if (this.isSubscribing() && this.subscribeDiscountCode && this.extraDiscountCents > 0) {
        body.attributes = {
          _mori_code_discount: String(this.extraDiscountCents),
          _mori_code_discount_label: this.extraDiscountLabel,
          // Lets the cart gift sync put the code back if applying it below fails.
          _mori_code_discount_code: this.subscribeDiscountCode.trim().toUpperCase(),
        };
      }
      if (cart?.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = this.dataset.sectionsUrl || window.location.pathname;
      }

      try {
        const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body),
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Could not add the gift set to your cart');
        }

        // Applying the code through /cart/update.js allocates it to the tin
        // line straight away and returns the drawer re-rendered with it, so
        // the drawer opens on the same total the page quoted. The sections
        // returned with the add predate the code and would read GBP 2 higher.
        // Shopify's /discount/{code} route is kept as a fallback only: the
        // local theme dev proxy answers it with a 401.
        if (this.isSubscribing() && this.subscribeDiscountCode) {
          // One retry: a background cart write landing at the same moment can
          // leave the first attempt without the code.
          const discounted =
            (await this.applySubscribeDiscountToCart(body.sections)) ||
            (await this.applySubscribeDiscountToCart(body.sections));
          if (discounted) {
            if (discounted.sections) data.sections = discounted.sections;
          } else if (!(await this.applySubscribeDiscount())) {
            window.location.href = this.discountUrl(window.routes?.cart_url || '/cart');
            return;
          }
        }

        if (cart) {
          cart.setActiveElement?.(document.activeElement);
          cart.renderContents?.(data);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        }
        // PUB_SUB_EVENTS is a top-level const, so it never appears on window.
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mori-gift-set-builder', cartData: data });
        }
        if (!cart) window.location = window.routes?.cart_url || '/cart';
      } catch (error) {
        this.errorEl.textContent = error.message || 'Something went wrong, please try again';
        this.errorEl.hidden = false;
      } finally {
        this.submitButton.removeAttribute('aria-disabled');
        this.buttonText.textContent = 'Add gift set to cart';
        this.spinner.hidden = true;
      }
    }
  }

  customElements.define('mori-gift-set-builder', MoriGiftSetBuilder);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mori-purchase-builder"] && !Shopify.designMode) return;
  try {
    class MoriPurchaseBuilder extends HTMLElement {
    static rules = {
      always: { unlocked: () => true, locked: '' },
      subscribe: { unlocked: (s) => s.isSubscription, locked: 'Subscribe' },
      tins_2: { unlocked: (s) => s.tins >= 2, locked: 'Add 2 tins' },
      tins_3: { unlocked: (s) => s.tins >= 3, locked: 'Add 3 tins' },
      subscribe_or_tins_2: { unlocked: (s) => s.isSubscription || s.tins >= 2, locked: 'Subscribe' },
      subscribe_and_tins_3: { unlocked: (s) => s.isSubscription && s.tins >= 3, locked: 'With 3-tin sub' },
    };

    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form) return;
      this.variantInput = this.form.querySelector('[name="id"]');
      this.sellingPlanInput = this.querySelector('[name="selling_plan"]');
      this.subscribeInput = this.querySelector('[value="subscription"]');
      this.money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: this.dataset.currency || 'GBP' });
      this.querySelectorAll('input').forEach((input) => input.addEventListener('change', () => this.update()));
      // Google Shopping listings show the one-off price, so visitors from them land on Buy once to match.
      const params = new URLSearchParams(window.location.search);
      if (params.has('gclid') || params.get('utm_medium') === 'product_sync') {
        const onceInput = this.querySelector('[value="once"]');
        if (onceInput) onceInput.checked = true;
      }
      this.update();
    }

    update() {
      const amount = this.querySelector('[name^="mori-amount"]:checked');
      if (!amount) return;
      const state = { isSubscription: this.subscribeInput.checked, tins: Number(amount.dataset.tins || 1) };
      const plan = state.isSubscription ? 'subscription' : 'once';
      const price = amount.dataset[`${plan}Price`];
      const frequency = this.updateSellingPlan(amount, state.isSubscription);

      if (this.variantInput) this.variantInput.value = amount.value;

      this.querySelectorAll('[name^="mori-amount"]').forEach((input) => {
        const pill = input.nextElementSibling.querySelector('[data-amount-pill]');
        const saving = Number(input.dataset[`${plan}Saving`] || 0);
        pill.hidden = saving < 1 || input.dataset.tins === '1';
        pill.querySelector('[data-amount-saving]').textContent = saving;
      });

      // Perk pills on the tin buttons are for one-off orders only; Subscribe carries its own perk pill.
      this.querySelectorAll('[data-amount-perk]').forEach((perk) => {
        // The kit comes with 90g on either plan, so its pill stays; the whisk is already a Subscribe perk.
        perk.hidden = plan !== 'once' && !perk.hasAttribute('data-perk-always');
      });

      const planPill = this.querySelector('[data-plan-pill]');
      const subscriptionSaving = Number(amount.dataset.subscriptionSaving || 0);
      planPill.hidden = subscriptionSaving < 1;
      planPill.querySelector('[data-plan-saving]').textContent = subscriptionSaving;

      // Drives the sticky add-to-cart bar's "Save X%" label, so it always reflects
      // whichever plan and tin count is currently selected, not just the subscription pill.
      const currentSaving = Number(amount.dataset[`${plan}Saving`] || 0);
      this.dataset.currentSavingPercent = String(currentSaving);

      // Lead with the per-tin price so the bundle and subscription saving is obvious; total sits underneath.
      const perTin = Number(amount.dataset[`${plan}Cents`] || 0) / state.tins;
      const fullPerTin = Number(this.dataset.unitFullCents || 0);
      const fullPrice = this.querySelector('[data-full-price]');
      const orderTotal = this.querySelector('[data-order-total]');
      this.querySelector('[data-current-price]').textContent = this.money.format(Math.round(perTin) / 100);
      fullPrice.textContent = this.money.format(fullPerTin / 100);
      fullPrice.hidden = Math.round(perTin) >= fullPerTin;
      const totalAmount = document.createElement('strong');
      totalAmount.textContent = price;
      orderTotal.replaceChildren(totalAmount, ' total');
      orderTotal.hidden = state.tins === 1;
      // The delivery cadence is its own tick below, so the order line only flags one-off orders.
      this.querySelector('[data-order-line]').textContent = state.isSubscription && frequency
        ? amount.dataset.title
        : `${amount.dataset.title}, one-off`;
      const frequencyLabel = this.querySelector('[data-frequency-label]');
      if (frequencyLabel && frequency) frequencyLabel.textContent = frequency;
      this.querySelectorAll('[data-subscription-perk]').forEach((perk) => {
        perk.hidden = !state.isSubscription;
      });

      let giftsWorth = 0;
      const hasKit = !!this.querySelector('[data-gift][data-rule="tins_3"]');
      this.querySelectorAll('[data-gift]').forEach((gift) => {
        const rule = MoriPurchaseBuilder.rules[gift.dataset.rule] || MoriPurchaseBuilder.rules.always;
        // The essentials kit includes a whisk, so the separate whisk isn't given or counted on 3-tin orders.
        const inKit = hasKit && gift.dataset.rule === 'subscribe_or_tins_2' && state.tins >= 3;
        // It still shows ticked so customers can see they're getting a whisk, it just isn't counted twice.
        const unlocked = rule.unlocked(state) && !inKit;
        const quantity = gift.dataset.perTin === 'true' ? state.tins : 1;
        gift.classList.toggle('is-unlocked', unlocked || inKit);
        let status = rule.locked;
        if (inKit) status = 'In essentials kit';
        else if (unlocked) status = quantity > 1 ? `Free ×${quantity}` : 'Free';
        gift.querySelector('[data-gift-status]').textContent = status;
        if (unlocked) giftsWorth += Number(gift.dataset.worth || 0) * quantity;
      });
      const worth = this.querySelector('[data-gifts-worth]');
      worth.hidden = giftsWorth === 0;
      worth.textContent = `${this.money.format(giftsWorth / 100).replace(/\.00$/, '')} value`;

      // Also drives the sticky add-to-cart bar's "Save X% + £Y" label, so its £Y
      // always matches whatever's currently unlocked (tin, whisk, delivery, kit).
      this.dataset.currentGiftsWorthCents = String(giftsWorth);
    }

    // Points selling_plan at this variant's plan for its cadence (12 weeks for 3 tins once that
    // plan exists, otherwise 4 weeks), falling back to the 4-week plan, then its first plan.
    updateSellingPlan(amount, isSubscription) {
      let plans = {};
      try {
        plans = JSON.parse(amount.dataset.plans || '{}');
      } catch (error) {
        plans = {};
      }
      const frequency = plans[amount.dataset.frequency] ? amount.dataset.frequency : this.dataset.frequency;
      const planId = plans[frequency] ?? Object.values(plans)[0];
      if (this.sellingPlanInput) {
        this.sellingPlanInput.disabled = !isSubscription || !planId;
        if (planId) this.sellingPlanInput.value = String(planId);
      }
      return planId ? frequency : null;
    }
  }
  if (!customElements.get('mori-purchase-builder')) customElements.define('mori-purchase-builder', MoriPurchaseBuilder);
  } catch(e) { console.error(e); }
})();

})();
